import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Cxcencregcomp } from "../cxcinterfaces/cxcencregcomp";
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { DatePipe } from '@angular/common';
import { CxcregcomprobanteService } from "../cxcservicios/cxcregcomprobante.service";
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import * as XLSX from 'xlsx';//CDPJ
import { Cxcdetregcomp } from '../cxcinterfaces/cxcdetregcomp';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { Cxcdetregcomptmp } from "../cxcinterfaces/cxcdetregcomptmp";
import { isNullOrUndefined } from 'util';
import { UploadfilesService } from '../../advantage/advantageservices/uploadfiles.service';
@Component({
  selector: 'app-cxcregcomprobante',
  templateUrl: './cxcregcomprobante.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class CxcregcomprobanteComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  @ViewChild('inputFile') inputfile: ElementRef

  indicador: any;
  permisoRegcomp: SegMaePermiso;
  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  lblbannombre;
  public frameworkComponents;
  rowSelection = 'multiple';
  defaultCxcregcomp;
  rowStyle;
  largo: string;
  detregcompSelected: Cxcdetregcomp;
  index = 0;

  displayDialogBus: boolean;
  displayDialogBusquedaFast: boolean;
  types: SelectItem[];
  busquedacampos: any[];
  tabla: string;
  consulta: string;
  arregloCons: any[];
  arregloBus: any[];
  where: string;
  opcion: string;
  spin: boolean;
  datosJson;

  constructor(
    public init: NuevoComponentService, public cxcregcomprobanteService: CxcregcomprobanteService,
    private busquedaSer: InvbusquedaService, private datePipe: DatePipe, private permisosService: PermisosService,
    private messageService: MessageService, private confirmationService: ConfirmationService, private auditoriagral: AuditoriagralService,
    public uploadFileService: UploadfilesService,
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.rowStyle = (params) => {
      if (params.data.COLOREXISTEDOC === 'Y') {
        return { background: 'rgb(245,236,166)' };
      }
    };
    this.defaultCxcregcomp = {
      editable: true,
      objeto: 'cxcregcomp',
      resizable: true
    };
  }
  columnDefsDetregcomp = [
    {
      headerName: 'No.', field: 'DETREGCOMPRO_NUMERO',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 80, cellStyle: { textAlign: 'right' },
      onCellDoubleClicked: (params) => {
        //this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Fecha', field: 'DETREGCOMPRO_FECHA',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 89, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        //this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Referencia', field: 'DETREGCOMPRO_REFERENCIA', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Comprobante', field: 'DETREGCOMPRO_COMPROBANTE', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Concepto', field: 'DETREGCOMPRO_CONCEPTO', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Importe', field: 'DETREGCOMPRO_IMPORTE', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 95, cellStyle: { textAlign: 'right' },
      onCellDoubleClicked: (params) => {
        ///this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Cliente', field: 'CLI_CODIGO', editable: (params) => {
        return this.validaciboolena(params)
      }, cellEditor: 'cellPrueba', width: 95,
      cellStyle: { textAlign: 'left' },
      cellEditorParams:
      {

        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 20,
          opcionbuscar: true
        }

      }
    },
    {
      headerName: 'Nombre', field: 'CLI_NOMBRE', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Referencia', field: 'DETREGCOMPRO_REFERENCIA2', editable: (params) => {
        return this.validaciboolena(params)
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 100
        }
      }
    },
    {
      headerName: 'CI', field: 'TRNCOBRO_NRODOC', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    }
  ];

  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    console.log(this.indicador)
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.lblbannombre = ''
    this.cxcregcomprobanteService.encregcomp[this.indicador] = {};
    this.cxcregcomprobanteService.detregcomp = [];

    await this.getPermisos()
    console.log(this.cxcregcomprobanteService.detregcomp)
    this.spin = false;

    //console.log(this.encfacService.encfacarray[this.indicador])

    this.detregcompSelected = {};
    this.largo = '-5800';
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoRegcomp = data[0];
        } else {
          this.permisoRegcomp = null;
        }
      } else {
        this.permisoRegcomp = null;
      }
    } catch (e) {
      this.permisoRegcomp = null;
      this.messageService.add({
        key: 'cxcregcom',
        severity: 'error',
        summary: 'Información',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  limpiar() {
    this.cxcregcomprobanteService.encregcomp[this.indicador] = {
      ENCREGCOMPRO_NUMERO: '',
      COM_CODIGO: '01',
      ENCREGCOMPRO_FECHA: '',
      ENCREGCOMPRO_CONCEPTO: '',
      USUIDENTIFICACION: '',
      BAN_CODIGO: ''
    }
    this.cxcregcomprobanteService.detregcomp = [];
  }
  manejarSenales(valor) {
    if (valor === 'Nuevo') {
      if (this.permisoRegcomp.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoRegcomp.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'cxcregcom',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada'
          });
        }
      }

    }
    if (valor === 'Cancelar') {
      this.cancelar();
    }
    if (valor === 'Borrar') {
      if (this.permisoRegcomp.PERTODO === 1) {
        let numci = 0
        for (const iterator of this.cxcregcomprobanteService.detregcomp) {
          if (iterator.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(iterator.TRNCOBRO_NRODOC) === false) {
            numci++
          }
        }
        if (numci > 0) {
          this.messageService.add({
            key: 'cxcregcom',
            severity: 'error',
            summary: 'Información',
            detail: 'No se puede eliminar todo el registro ya que existen documentos registrados en cartera'
          });
          return;
        }

        this.borrar();
      } else {
        if (this.permisoRegcomp.PERELIMACION === 1) {
          let numci = 0
          for (const iterator of this.cxcregcomprobanteService.detregcomp) {
            if (iterator.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(iterator.TRNCOBRO_NRODOC) === false) {
              numci++
            }
          }
          if (numci > 0) {
            this.messageService.add({
              key: 'cxcregcom',
              severity: 'error',
              summary: 'Información',
              detail: 'No se puede eliminar todo el registro ya que existen documentos registrados en cartera'
            });
            return;
          }
          this.borrar();
        } else {
          this.messageService.add({
            key: 'cxcregcom',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada'
          });
        }
      }
    }
    if (valor === 'Buscar') {
      if (this.permisoRegcomp.PERTODO === 1) {
        this.busqueda();
      } else {
        if (this.permisoRegcomp.PERSELECCION === 1) {
          this.busqueda();
        } else {
          this.messageService.add({
            key: 'cxcregcom',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos para consultar, acción denegada'
          });
        }
      }
    }
    if (valor === 'Guardar') {
      if (this.permisoRegcomp.PERTODO === 1) {
        this.validarGuardar();
      } else {
        if (this.permisoRegcomp.PERINSERCION === 1) {
          this.validarGuardar();
        } else {
          this.messageService.add({
            key: 'cxcregcom',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada'
          });
        }
      }
    }
    if (valor === 'Descargar') {
      this.descargarDemo()
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  async descargarDemo() {
    try {
      const rs: any = await this.uploadFileService.getDocument('REGISTRO_COMPROBANTES_DEMO.xlsx');
      this.downloadDocument(rs.respuesta, 'REGISTRO_COMPROBANTES_DEMO.xlsx');
    } catch (err) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrio un error al encontrar el archivo'
      });
    }
  }
  downloadDocument(strBase64, filename) {
    const byteCharacters = atob(strBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const data = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = data;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 1000)
  }
  async borrar() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'cxcregcomprobante',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {
          let numci = 0
          let numero = this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO
          for (const iterator of this.cxcregcomprobanteService.detregcomp) {
            if (iterator.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(iterator.TRNCOBRO_NRODOC) === false) {
              numci++
            }
          }
          if (numci > 0) {
            this.messageService.add({
              key: 'cxcregcom',
              severity: 'error',
              summary: 'Información',
              detail: 'No se puede eliminar todo el documento ya que existen documentos registrados en cartera'
            });
            return;
          }
          this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO = ''
          await this.cxcregcomprobanteService.borrarRegistro(numero)
          await this.auditoriagral.registrarAuditoria('CXC_ENCREGCOMPRO',
          numero + '/Banco:' + this.cxcregcomprobanteService.encregcomp[this.indicador].BAN_CODIGO, 'E',
              '', '01', '', '', '', '').toPromise();

          await this.cancelar()
          this.messageService.add({
            key: 'cxcregcom',
            severity: 'success',
            summary: 'Información',
            detail: 'El registro se eliminó de forma correcta'
          });

        } catch (error) {
          this.messageService.add({
            key: 'cxcregcom',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un erro durante la eliminación ' + error
          });
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async busqueda() {
    this.opcion = 'BUSCARREG';
    this.types = [
      { label: 'Número', value: 'ENCREGCOMPRO_NUMERO' },
      { label: 'FECHA', value: 'ENCREGCOMPRO_FECHA' },
      { label: 'Concepto', value: 'ENCREGCOMPRO_CONCEPTO' },

    ];
    this.busquedacampos = ['', '', ''];
    this.tabla = 'CXC_ENCREGCOMPRO';
    this.where = ' encregcompro_numero is not null order by 1 desc';
    this.busquedaSer.busquedaRegCXCComprobante().subscribe((res: any[]) => {
      this.arregloCons = res;
      this.arregloCons.map((dato) => {
        if (dato.ENCREGCOMPRO_FECHA !== null) {
          dato.ENCREGCOMPRO_FECHA = this.datePipe.transform(dato.ENCREGCOMPRO_FECHA, 'dd/MM/yyyy');
        } else {
          dato.ENCREGCOMPRO_FECHA = '';
        }
      });
      this.displayDialogBusquedaFast = true;
    });
  }
  seleccionItem(params) {
    if (params === 'subirxls') {
      if (this.cxcregcomprobanteService.encregcomp[this.indicador].BAN_CODIGO === null ||
        this.cxcregcomprobanteService.encregcomp[this.indicador].BAN_CODIGO === undefined ||
        this.cxcregcomprobanteService.encregcomp[this.indicador].BAN_CODIGO === '') {
        this.messageService.add({
          key: 'cxcregcom',
          severity: 'error',
          summary: 'Información',
          detail: 'El código del banco no puede estar vacío'
        });
        return;
      }
      this.inputfile.nativeElement.click();
      return;
    }
    if (params === 'eliminar') {
      if (this.detregcompSelected.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(this.detregcompSelected.TRNCOBRO_NRODOC) === false) {
        this.messageService.add({
          key: 'cxcregcom',
          severity: 'error',
          summary: 'Información',
          detail: 'No puede eliminar un registro ya cruzado'
        });
        return;
      }
      this.confirmeliminaregistro()
      return
    }

    if (params.object !== undefined) {
      this.detregcompSelected = params.object;
    }
  }
  confirmeliminaregistro() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'cxcregcomprobante',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {
          let cod = this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO
          if (isNullOrUndefined(cod) || cod === '') {
            this.cxcregcomprobanteService.detregcomp = this.cxcregcomprobanteService.detregcomp.filter((val, j) => j !==
              this.cxcregcomprobanteService.detregcomp.indexOf(this.detregcompSelected));
            this.cxcregcomprobanteService.calculartota()
            this.aggrid.refreshaggrid(this.cxcregcomprobanteService.detregcomp, this.defaultCxcregcomp.objeto);
          } else {
            await this.cxcregcomprobanteService.eliminadetregistro(this.detregcompSelected);

            await this.auditoriagral.registrarAuditoria('CXC_DETREGCOMPRO',
              this.detregcompSelected.ENCREGCOMPRO_NUMERO + '/' + this.detregcompSelected.BAN_CODIGO
              + '/' + this.detregcompSelected.DETREGCOMPRO_COMPROBANTE + '/' + this.detregcompSelected.CLI_CODIGO, 'E',
              '', '01', '', '', '', '').toPromise();

            this.cxcregcomprobanteService.detregcomp = this.cxcregcomprobanteService.detregcomp.filter((val, j) => j !==
              this.cxcregcomprobanteService.detregcomp.indexOf(this.detregcompSelected));
            this.cxcregcomprobanteService.calculartota()
            this.aggrid.refreshaggrid(this.cxcregcomprobanteService.detregcomp, this.defaultCxcregcomp.objeto);
          }

        } catch (error) {
          this.messageService.add({
            key: 'cxcregcom',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un erro durante la eliminación ' + error.error
          });
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  validarGuardar() {

    if (this.cxcregcomprobanteService.encregcomp[this.indicador].BAN_CODIGO === null ||
      this.cxcregcomprobanteService.encregcomp[this.indicador].BAN_CODIGO === undefined ||
      this.cxcregcomprobanteService.encregcomp[this.indicador].BAN_CODIGO === '') {
      this.messageService.add({
        key: 'cxcregcom',
        severity: 'error',
        summary: 'Información',
        detail: 'El código del banco no puede estar vacío'
      });
      return;
    }
    if (this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_FECHA === null ||
      this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_FECHA === undefined ||
      this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_FECHA === '') {
      this.messageService.add({
        key: 'cxcregcom',
        severity: 'error',
        summary: 'Información',
        detail: 'La fecha no puede estar vacía'
      });
      return;
    }
    this.guardar()
  }
  async guardar() {
    let numero = this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO
    try {
      if (numero === null || numero === undefined || numero === '') {
        if (this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_FECHA.toString().includes('-')) {
          this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_FECHA = this.datePipe.transform(this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_FECHA, 'dd/MM/yyyy')
        }
        const data = await this.cxcregcomprobanteService.insertarregistro(this.cxcregcomprobanteService.encregcomp[this.indicador])
        if (data.length > 0 && data !== null) {

          for (const iterator of data) {
            this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO = iterator.NUMERO
            await this.auditoriagral.registrarAuditoria('CXC_ENCREGCOMPRO',
              iterator.NUMERO + '/' + this.cxcregcomprobanteService.encregcomp[this.indicador].BAN_CODIGO, 'I',
              '', '01', '', '', '', '').toPromise();
            for (const item of this.cxcregcomprobanteService.detregcomp) {
              if (item.COLOREXISTEDOC === 'N') {
                if (item.DETREGCOMPRO_FECHA.toString().includes('-')) {
                  item.DETREGCOMPRO_FECHA = this.datePipe.transform(item.DETREGCOMPRO_FECHA, 'dd/MM/yyyy')
                }
                item.ENCREGCOMPRO_NUMERO = this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO
                item.DETREGCOMPRO_IMPORTE = Number(item.DETREGCOMPRO_IMPORTE)
                await this.cxcregcomprobanteService.insertarregistrodet(item)
                await this.auditoriagral.registrarAuditoria('CXC_DETREGCOMPRO',
                  item.ENCREGCOMPRO_NUMERO + '/' + item.BAN_CODIGO + '/' + item.DETREGCOMPRO_COMPROBANTE + '/' + item.CLI_CODIGO, 'I',
                  '', '01', '', '', '', '').toPromise();
              }
            }
          }

          this.messageService.add({
            key: 'cxcregcom',
            severity: 'success',
            summary: 'Información',
            detail: 'Éxito al guardar '
          });
          this.botonNuevo = false;
          this.botonGuardar = true;
          this.botonBorrar = false;
          this.botonRegresar = true;
          await this.cancelar()
        }
      } else {
        for (const item of this.cxcregcomprobanteService.detregcomp) {
          //if (item.COLOREXISTEDOC === 'N') {
          await this.cxcregcomprobanteService.actualizarregistrodet(item)
          await this.auditoriagral.registrarAuditoria('CXC_DETREGCOMPRO',
            item.ENCREGCOMPRO_NUMERO + '/' + item.BAN_CODIGO + '/' + item.DETREGCOMPRO_COMPROBANTE + item.CLI_CODIGO, 'A',
            '', '01', '', '', '', '').toPromise();
          //}
        }
        this.messageService.add({
          key: 'cxcregcom',
          severity: 'success',
          summary: 'Información',
          detail: 'Éxito al guardar '
        });
        this.botonNuevo = false;
        this.botonGuardar = true;
        this.botonBorrar = false;
        this.botonRegresar = true;
        await this.cancelar()
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxcregcom',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrio un error al guardar ' + error
      });
    }
  }
  busquedabanco(parametro) {
    this.opcion = 'BuscarBanco';
    this.types = [
      { label: 'CÓDIGO', value: 'BAN_CODIGO' },
      { label: 'BANCO', value: 'BAN_BANCO' },
      { label: 'CUENTA NRO', value: 'BAN_CTANRO' },
      { label: 'JEFE CUENTA', value: 'BAN_JEFECTA' },
      { label: 'SUCURSAL', value: 'BAN_SUCURSAL' },
      { label: 'DIRECCIÓN', value: 'BAN_DIRECCION' },
      { label: 'TELEFONO1', value: 'BAN_TELEFONO1' },
      { label: 'REF. CONTABLE', value: 'CON_CODIGO' },
      { label: 'CEN_CODIGO', value: 'CEN_CODIGO' },
      { label: 'TIPO DE CUENTA', value: 'BAN_TIPOCUENTA' },
      { label: 'DOC. POR PAGAR', value: 'CON_CODIGO_2' },
      { label: 'PROCESO', value: 'BAN_PROCESO_CM' },
      { label: 'DIRECTORIOCM', value: 'BAN_DIRECTORIO_CM' },
      { label: 'DINEROELEC', value: 'BAN_DINEROELEC' },
      { label: 'TELCEL', value: 'BAN_TELEFONOCEL' },
      { label: 'ULT. CHEQUE', value: 'BAN_ULTIMOCHEQUE' },
    ];
    this.busquedacampos = [parametro, '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];
    this.consulta = 'BAN_codigo,BAN_banco, NVL(BAN_ctanro, \'*\') AS BAN_ctanro, BAN_jefecta,BAN_sucursal,' +
      ' BAN_direccion, BAN_telefono1, NVL(CON_codigo, \'\') as CON_codigo, CEN_CODIGO,BAN_tipocuenta,' +
      ' con_codigo_2, ban_proceso_cm, ban_directorio_cm, ban_dineroelec, ban_telefonocel,BAN_ULTIMOCHEQUE';
    this.tabla = 'BAN_MAEBAN';
    this.where = '';

    this.cxcregcomprobanteService.encontrarBanco(this.types[0].value + ' LIKE \'' + parametro + '\'').subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busquedaSer.busquedaBanMaeBan2(parametro).subscribe((res: any[]) => {
            this.arregloCons = res;
            this.displayDialogBusquedaFast = true;
          });
        }
      } else {
        this.busquedaSer.busquedaBanMaeBan2(parametro).subscribe((res: any[]) => {
          this.arregloCons = res;
          this.displayDialogBusquedaFast = true;
        });
      }
    });
  }
  botonesmodificar() {

  }
  setFocus(event) {
    let element: any;
    switch (event.target.id) {
      case 'BAN_CODIGO': {
        this.busquedabanco(event.target.value);
        break;
      }
      default: {
        break;
      }
    }
  }
  changeTabs() {

  }
  nuevo() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.lblbannombre = ''
    this.cxcregcomprobanteService.encregcomp[this.indicador] = {
      ENCREGCOMPRO_NUMERO: '',
      COM_CODIGO: '01',
      ENCREGCOMPRO_FECHA: '',
      ENCREGCOMPRO_CONCEPTO: '',
      USUIDENTIFICACION: '',
      BAN_CODIGO: ''
    }
    this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_FECHA = new Date()
    this.cxcregcomprobanteService.detregcomp = [];
    document.getElementById('contorno').style.pointerEvents = 'all';
    setTimeout(() => {
      document.getElementById('BAN_CODIGO').focus();
    }, 100);
    
  }
  cancelar() {
    if (this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO === null || this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO === undefined
      || this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO === '') {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.lblbannombre = ''
      this.cxcregcomprobanteService.encregcomp[this.indicador] = {
        ENCREGCOMPRO_NUMERO: '',
        COM_CODIGO: '01',
        ENCREGCOMPRO_FECHA: '',
        ENCREGCOMPRO_CONCEPTO: '',
        USUIDENTIFICACION: '',
        BAN_CODIGO: ''
      }
      this.cxcregcomprobanteService.detregcomp = [];
      console.log(this.cxcregcomprobanteService.detregcomp)
      document.getElementById('contorno').style.pointerEvents = 'none';

    } else {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.encontrarregistro(this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO)
    }
  }
  async encontrarregistro(numero) {
    try {
      const res1 = await this.cxcregcomprobanteService.getenccoprobante(numero)
      const res2 = await this.cxcregcomprobanteService.getdetcoprobante(numero)
      if (res1 !== null) {
        for (const iterator of res1) {
          //if ((iterator.ENCREGCOMPRO_FECHA).toString().includes('-')) {
          iterator.ENCREGCOMPRO_FECHA = new Date(iterator.ENCREGCOMPRO_FECHA)//this.datePipe.transform(iterator.ENCREGCOMPRO_FECHA,'DD/MM/YYYY')
          //}

          this.cxcregcomprobanteService.encregcomp[this.indicador] = iterator
          this.lblbannombre = iterator.BAN_NOMBRE
          if (res2 !== null) {
            let numero = 1;
            for (const item of res2) {
              if (item.DETREGCOMPRO_FECHA.toString().includes('-')) {
                item.DETREGCOMPRO_FECHA = this.datePipe.transform(item.DETREGCOMPRO_FECHA, 'dd/MM/yyyy')
              }
              item.DETREGCOMPRO_IMPORTE = Number(item.DETREGCOMPRO_IMPORTE).toFixed(2)
              item.DETREGCOMPRO_NUMERO = numero
              numero++;
            }
            this.cxcregcomprobanteService.detregcomp = res2;
          }
        }
        this.cxcregcomprobanteService.calculartota();
      }
    } catch (error) {

    }
  }
  manejarSeleccion(opcion) {
    if (this.opcion === 'BuscarBanco') {
      this.cxcregcomprobanteService.encregcomp[this.indicador].BAN_CODIGO = opcion.BAN_CODIGO
      this.lblbannombre = opcion.BAN_BANCO;
      document.getElementById('ENCREGCOMPRO_CONCEPTO').focus();
    }
    if (this.opcion === 'BUSCARREG') {
      this.encontrarregistro(opcion.ENCREGCOMPRO_NUMERO)
    }
    this.displayDialogBusquedaFast = false
  }
  async onBasicUpload(ev) {
    let validacionVacio = true;
    console.log(ev[0]);
    console.log(ev);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellDates: true, cellNF: false, cellText: false });

      jsonData = workBook.SheetNames.reduce((initial, name) => {
        console.log(workBook.Sheets[name]);
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, { defval: '' });
        return initial;
      }, {});
      console.log(jsonData.Hoja1);

      for (let data of jsonData.Hoja1) {

        delete data.__EMPTY;
        for (let key in data) { // se revisa los campos del json generado del excel,
          // si uno de esos campos no existe o está vacío no se activará el boton de guardar
          if (data[key] === '') {
            validacionVacio = false;
          }

        }
      }
      this.datosJson = jsonData.Hoja1;
      console.log(this.datosJson)
      this.inputfile.nativeElement.value = ''

      await this.validaexcell();

    }
    reader.readAsBinaryString(file);
  }
  async validaexcell() {
    this.spin = true
    try {
      let reg: Cxcdetregcomptmp = {}
      let nuevodetreg = []
      if (this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO === ''
        || isNullOrUndefined(this.cxcregcomprobanteService.encregcomp[this.indicador].ENCREGCOMPRO_NUMERO)) {
        this.cxcregcomprobanteService.detregcomp = []
      }
      await this.cxcregcomprobanteService.eliminatemporal()
      for (const item of this.datosJson) {
        reg = {}
        //const linea = this.cxcregcomprobanteService.detregcomp.length;
        reg.DETREGCOMPRO_REFERENCIA = item.REFERENCIA
        reg.DETREGCOMPRO_COMPROBANTE = item.COMPROBANTE.toString()
        reg.DETREGCOMPRO_CONCEPTO = item.CONCEPTO
        reg.DETREGCOMPRO_IMPORTE = Number(item.IMPORTE)
        reg.DETREGCOMPRO_FECHA = item.FECHA.toString()//new Date(item.FECHA)
        //reg.DETREGCOMPRO_FECHA = this.datePipe.transform(reg.DETREGCOMPRO_FECHA, 'dd/MM/yyyy')
        //console.log(reg)
        await this.cxcregcomprobanteService.registrartemporal(reg)
      }
      const resp = await this.cxcregcomprobanteService.getregistrartemporal()

      if (resp !== null) {
        let numero = 1;
        for (const item of resp) {

          item.DETREGCOMPRO_REFERENCIA = item.DETREGCOMPRO_REFERENCIA.toString().substring(0, 100);
          item.DETREGCOMPRO_COMPROBANTE = item.DETREGCOMPRO_COMPROBANTE.toString().substring(0, 50);
          item.DETREGCOMPRO_CONCEPTO = item.DETREGCOMPRO_CONCEPTO.toString().substring(0, 100)
          item.DETREGCOMPRO_IMPORTE = Number(item.DETREGCOMPRO_IMPORTE).toFixed(2)

          if (item.DETREGCOMPRO_FECHA.toString().includes('-')) {
            item.DETREGCOMPRO_FECHA = this.datePipe.transform(item.DETREGCOMPRO_FECHA, 'dd/MM/yyyy')
          }
          let nuevodetRegcomp = {
            DETREGCOMPRO_NUMERO: numero,
            ENCREGCOMPRO_NUMERO: '',
            COM_CODIGO: '01',
            BAN_CODIGO: this.cxcregcomprobanteService.encregcomp[this.indicador].BAN_CODIGO,
            DETREGCOMPRO_FECHA: item.DETREGCOMPRO_FECHA,
            DETREGCOMPRO_REFERENCIA: item.DETREGCOMPRO_REFERENCIA,
            DETREGCOMPRO_COMPROBANTE: item.DETREGCOMPRO_COMPROBANTE,
            DETREGCOMPRO_CONCEPTO: item.DETREGCOMPRO_CONCEPTO,
            DETREGCOMPRO_REFERENCIA2: '',
            CLI_CODIGO: '',
            CLI_NOMBRE: '',
            DETREGCOMPRO_IMPORTE: item.DETREGCOMPRO_IMPORTE,
            TRNCOBRO_NRODOC: '',
            DETREGCOMPRO_ESTADO: '',
            COLOREXISTEDOC: item.COLOREXISTEDOC
          };
          //nuevodetreg.push(nuevodetRegcomp)
          this.cxcregcomprobanteService.detregcomp.push(nuevodetRegcomp);
          this.detregcompSelected = nuevodetRegcomp;
          numero++;
        }
        this.spin = false;
        this.cxcregcomprobanteService.calculartota();
        this.aggrid.refreshaggrid(this.cxcregcomprobanteService.detregcomp, this.defaultCxcregcomp.objeto);
        console.log(this.cxcregcomprobanteService.detregcomp)
      }
      this.spin = false;
    } catch (error) {
      console.log(error)
      this.spin = false;
    }

  }
  cambio(evento) {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
  }
  validaciboolena(params) {
    if (params.data.TRNCOBRO_NRODOC === '' || isNullOrUndefined(params.data.TRNCOBRO_NRODOC)) {
      return true
    } else {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = true;
      this.botonRegresar = false;
      return false
    }
  }
  
}
